// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtEnrollmentSurveyQuestionModel {
    static getAttributeTypeMap() {
        return ExtEnrollmentSurveyQuestionModel.attributeTypeMap;
    }
}
ExtEnrollmentSurveyQuestionModel.discriminator = undefined;
ExtEnrollmentSurveyQuestionModel.additionalProperties = false;
ExtEnrollmentSurveyQuestionModel.attributeTypeMap = [
    {
        "name": "surveyId",
        "baseName": "surveyId",
        "type": "number"
    },
    {
        "name": "questionId",
        "baseName": "questionId",
        "type": "number"
    },
    {
        "name": "answerKey",
        "baseName": "answerKey",
        "type": "number"
    },
    {
        "name": "answerText",
        "baseName": "answerText",
        "type": "string"
    },
];
//# sourceMappingURL=extEnrollmentSurveyQuestionModel.js.map